import { ReactNode } from "react";

import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app/app-sidebar";
import { Header } from "@/components/app/header";

interface MainLayoutProps {
  children: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <SidebarProvider
      className="flex h-screen bg-background"
      defaultOpen={false}
    >
      <AppSidebar />

      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto">
          <div
            className="p-6"
            style={{
              background: "linear-gradient(135deg, #f8faff 0%, #e6f3ff 100%)",
              minHeight: "100%",
            }}
          >
            {children}
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
